<div class="flex-steps-wrapper" [ngStyle]="{background: block.data.background}">
    <div class="container-lg">
        <div class="flex-steps-wrapper__content row">
            <div class="flex-steps-wrapper__column col-md-12 text-center">
                <h2 class="flex-steps-wrapper__header" [innerHTML]="block.data.text ? block.data.text : block.data.heading"></h2>
            </div>
        </div>
        <div class="flex-steps-row" *ngFor="let item of block.content; let stepCount = index; trackBy: trackByFn">
            <div id="box-{{stepCount+1}}" class="circle box-{{stepCount+1}}">
                <svg xmlns="http://www.w3.org/2000/svg" width="4" height="100%" class="line" id="line-wrapper-{{stepCount+1}}">
                    <g stroke="#fa582d" stroke-width="4">
                        <path id="line-{{stepCount+1}}" d="M0 0V500" />
                    </g>
                </svg>
                <div class="linedotted"></div>
            </div>
            <ng-container *ngIf="(item.data.alignment === 'left')">
                <div class="flex-step flex-step--left" *ngIf="contentLoaded[stepCount+1]" [@fadeInLeftOnEnter]="{ value: '', params: { duration: block.data.animationSlideSpeed } }" [@fadeOutLeftOnLeave]="{ value: '', params: { duration: block.data.animationSlideSpeed } }">
                    <h3 class="step-title">{{item.data.title}}</h3>
                    <div
                        class="step-content"
                        [ngClass]="{
                            container: block.data.columnsSmall == 'full' ||  block.data.columnsNormal == 'full',
                            'col-sm-12': block.data.columnsSmall == 'full',
                            'col-md-12': block.data.columnsNormal == 'full'
                        }"
                    >
                        <core-block
                            *ngFor="let subBlock of item.content"
                            [block]="subBlock"
                            class="subWidget {{subBlock.data.class}}"
                        >
                        </core-block>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="(item.data.alignment === 'right')">
                <div class="flex-step flex-step--right" *ngIf="contentLoaded[stepCount+1]" [@fadeInRightOnEnter]="{ value: '', params: { duration: block.data.animationSlideSpeed } }" [@fadeOutRightOnLeave]="{ value: '', params: { duration: block.data.animationSlideSpeed } }">
                    <h3 class="step-title">{{item.data.title}}</h3>
                    <div
                        class="step-content"
                        [ngClass]="{
                            container: block.data.columnsSmall == 'full' ||  block.data.columnsNormal == 'full',
                            'col-sm-12': block.data.columnsSmall == 'full',
                            'col-md-12': block.data.columnsNormal == 'full'
                        }"
                    >
                        <core-block
                            *ngFor="let subBlock of item.content"
                            [block]="subBlock"
                            class="subWidget {{subBlock.data.class}}"
                        >
                        </core-block>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
